
/**
 * 电话一键拨号链接（tel: 协议）
 *
 * 职责：把一个电话号码渲染成可点击的 tel: 链接，点击即调起系统拨号应用。
 *  - 无号码（空/null/undefined）：渲染"暂无联系电话"灰字，不生成空链接
 *  - 显示保留原始格式（含空格/横线/括号）；href 用去除空白、-、() 后的纯净号码
 *    （保留 + 与数字，兼容国际前缀）
 *  - @click.stop：防止点击拨号冒泡触发父级（如抽屉关闭、卡片展开）
 *
 * 复用范围：订单详情联系人电话（admin/operator/courier 三角色内部）。
 * 铁律：禁止各页面自行写 tel: 链接，禁止在此添加 emoji 图标，统一用本组件。
 */
export default {
  name: 'PhoneCallButton',
  props: {
    phone: { type: String, default: '' }
  },
  computed: {
    telHref () {
      const cleaned = String(this.phone || '').replace(/[\s\-()]/g, '')
      return 'tel:' + encodeURIComponent(cleaned)
    }
  }
}
